import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-info';
export var ID = 'icon-info';
/* eslint-disable max-len */

export var SVGInfo = function SVGInfo() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 10 10"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    fill: "currentColor",
    width: "10",
    height: "10",
    rx: "72"
  }), React.createElement("path", {
    d: "M5.078 1.157c.243 0 .45.085.62.256.17.17.256.377.256.62 0 .245-.085.454-.256.624-.17.17-.377.256-.62.256-.242 0-.45-.085-.62-.256-.17-.17-.256-.377-.256-.62 0-.24.088-.446.263-.62.176-.174.38-.26.613-.26zm.776 2.135V6.83c0 .168.01.272.028.31.02.04.054.068.103.09.05.02.16.03.333.03h.258v.924H3.618V7.26h.254c.166 0 .272-.01.318-.026.046-.018.08-.047.103-.09.022-.04.034-.123.034-.248V4.613h-.71v-.9c.253-.013.495-.04.726-.082.232-.04.438-.09.62-.147.118-.038.264-.102.436-.19h.454z",
    fill: "#FFF"
  })));
};
/* eslint-disable max-len */

var Info = function Info(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGInfo
  });
};

Info.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Info;